import React from "react";
import { ImageDelete } from "../../components/displays";

const ImageDeletion = () => <ImageDelete page />;

export default ImageDeletion;
